import PeopleList from './peopleList'

const peopleList = new PeopleList()
peopleList.init()
